import { Badge } from '@/features/common/components/badge';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
`;

const QuestionName = styled.p`
  margin: 0;
  font-weight: 500;
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
`;

const CustomQuestionBadge = styled(Badge)`
  margin-left: 12px;
`;

export const PreviewHeader = {
  Wrapper,
  QuestionName,
  Actions,
  CustomQuestionBadge,
};
